// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './styles/public.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from "axios"
import echarts from 'echarts'
import animated from 'animate.css'
import 'babel-polyfill'
import '../node_modules/echarts/map/js/province/shandong.js'

// 自定义组件引用
import NavBarCommon from '@/components/NavbarComponents20231101.vue';
import FilterConditionVue from "@/components/FilterCondition/index.vue";
import FooterCommon from "@/components/footerFail";

import { spArr } from '@/common';

// 动画库 animate
import "vue2-animate/dist/vue2-animate.min.css";

// 自定义样式引用
import "./styles/element-ui-reset.scss";
import "./styles/common.scss";

// 全屏滚动 vue-fullpage.js
import "fullpage.js/vendors/scrolloverflow";
import "./../static/fullPage.min.css";
import VueFullpage from "vue-fullpage.js";

// swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
// import 'swiper/css/swiper.css';
import "./assets/css/swiper.min.css";


Vue.prototype.echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts

Vue.use(ElementUI).use(VueFullpage).use(animated).use(VueAwesomeSwiper);

Vue.prototype.spArr = spArr;

Vue.component('FilterConditionVue', FilterConditionVue);
Vue.component('NavBarCommon', NavBarCommon);
Vue.component('FooterCommon', FooterCommon);

/* eslint-disable no-new */
new Vue({
  el: '#appMain',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js